<template>
  <article class="trainers">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
             Titulares
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="newHeadline()"
              >
                Crear nuevo Titular
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findNews()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="">
        <div class="py-2 px-4">
          <button
            class="faccess_button my-3"
            @click="updateToInactiveNews()"
            :disabled="news.length > 0 ? false : true"
          >
            Deshabilitar {{ news.length > 0 ? '('+news.length+ ')' : '' }}
          </button>
        </div>
        <v-divider></v-divider>
        <v-data-table
          v-model="news"
          :headers="options_table.headers_table"
          :items="filteredNews"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">

            <tr>
              <th>
                <v-checkbox
                  :input-value="props.all"
                  :indeterminate="props.indeterminate"
                  color="#1476FB"
                  hide-details
                  @click.native="toggleAll"
                ></v-checkbox>
              </th>
              <th
                v-for="header in props.headers"
                :key="header.text"
                class="text-xs-left"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)">
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr >
              <!-- :active="props.selected" @click="props.selected = !props.selected" -->
              <td>
                <v-checkbox
                  :input-value="props.selected"
                  color="#1476FB"
                  hide-details
                  @change="toggleOne(props)"
                >
                </v-checkbox>
              </td>
              <td v-show="false"
                  class="text-xs-left id_new">{{ props.item.id  }}</td>
              <td
                class="text-xs-left"
                @click="editHeadline(props.item.id, specialDate(props.item.attributes.publication_date))"
                style="cursor:pointer">{{ props.item.attributes.name }}</td>
              <td
                class="text-xs-left email"
                @click="editHeadline(props.item.id, specialDate(props.item.attributes.publication_date))"
                style="cursor:pointer">{{ specialDate(props.item.attributes.publication_date) }}</td>
            </tr>
          </template>
        </v-data-table>
      </div>
    </div>

    <new-news-headline
      v-if="active_modal_news_headline"
      @handleCancelNewsHeadline="cancelNewsHeadline"
      :id="id_selection"
      :action="action_select"
      :active_modal="active_modal_news_headline">
    </new-news-headline>

  </article>
</template>

<script>
import NewNewsHeadline from './Modal_new_edit_news'

export default {
  props: ['type'],
  data(){
    return{
      current_date_text: '',
      id_selection: null,
      action_select: null,
      active_modal_news_headline: false,
      selected: 'Todos las empresas',
      news:[],
      set_news: [],
      news_for_select: [],
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Nombre',
            align: 'left',
            value: 'attributes.name'
          },
          {
            text: 'Fecha',
            align: 'left',
            value: 'attributes.created_at'
          },
        ],
        filters: {
          gender: [],
          location_name: [],
          age: [],
          access_state:[]
        },
      },
    }
  },
  components: {
    'new-news-headline': NewNewsHeadline
  },
  computed: {
    filteredNews() {
      return this.news_for_select.filter(d => {
        return Object.keys(this.options_table.filters).every(f => {
          return this.options_table.filters[f].length < 1 || this.options_table.filters[f].includes(d[f])
        })
      })
    }
  },
  methods:{
    shortDate(date){
      let new_date =  date.substring(0,date.indexOf('T'))
      return new_date
    },
    findNews(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_state',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            company: this.getCompany().id
          }
        })
        .then(function(response){
          this.news = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsByType(){
      try {
        this.$http.get('app/articles/'+this.type+'/show_by_news_type',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
          params: {
            company: this.getCompany().id
          }
        })
        .then(function(response){
          this.news_for_select = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    findNewsTypeOrState(){
      if (this.type === 'all' || this.type === 'public' || this.type === 'hidden'){
        this.findNews()
      }
      if (this.type === 'Normal' || this.type === 'Video' || this.type === 'Titular') {
        this.findNewsByType()
      }
    },
    specialDate(a_date){
      let meses = new Array ("Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre");
      let date = a_date.substring(0, 10) + ' 00:00:00'
      var f=new Date(date);
      return f.getDate() + " de " + meses[f.getMonth()] + " de " + f.getFullYear()
    },
    toggleAll () {
      /* var vm = this;
      var emails = document.querySelectorAll("table.v-datatable td.id_new");
      var check = document.querySelector(".v-table thead [aria-checked]").getAttribute("aria-checked");
      if (check=="false") {
        emails.forEach(function(element) {
          vm.news.splice(vm.news.indexOf(vm.filteredNews.find( news => news.id === element.innerHTML )),1);
        });
      }else{
        emails.forEach(function(element) {
          if(vm.news.indexOf(vm.filteredNews.find( news => news.id === element.innerHTML ))==-1){
            vm.news.push(vm.filteredNews.find( news => news.id === element.innerHTML ));
          }
        });
      } */
      this.news = this.news.length === 0 ? this.news : [];
    },
    toggleOne({ item }){
      if(!this.news.find(e => e.id.toString() === item.id.toString() )) {
        this.news.push(item)
      } else {
        this.news = this.news.filter(e => e.id.toString() !== item.id.toString())
      }
    },
    updateToInactiveNews(){
      this.set_news = this.news.map((e)=> ({ id: e.id, type: false }) )
      console.log('this.set_news ', this.set_news)
      try {
        this.$http.post('app/articles/enabled_disabled',{ data: this.encrypt(this.set_news).toString() },
         {
          headers:
            {
              "X-Device-ID" : this.getDeviceId(),
              "Authorization" : 'Bearer ' + this.getUserToken()
            }
        }).then(function(response){
          this.$router.push({name: 'news_headline'})
          this.findNewsTypeOrState();
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    cancelNewsHeadline(event){
      this.active_modal_news_headline = event
      this.findNewsTypeOrState();
    },
    changeDate(val){
      // cl val
      this.event.attributes.publication_date = val
    },
    editHeadline(id, date_text){
      this.id_selection = id
      this.action_select= 'edit'
      this.current_date_text = date_text
      this.active_modal_news_headline = true
    },
    newHeadline(){
      this.action_select= 'new'
      this.active_modal_news_headline = true
    },
    changeSort (column) {
      if (this.options_table.pagination.sortBy === column) {
        this.options_table.pagination.descending = !this.options_table.pagination.descending
      } else {
        this.options_table.pagination.sortBy = column
        this.options_table.pagination.descending = false
      }
    },
  },
  mounted(){
    this.findNewsTypeOrState();
  },
  watch: {
    $route(to, from) {
      this.findNewsTypeOrState();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/news/headline/Index.vue